export const validateUsername = (firstName, lastName) => {
	const patternFirstName = /^[a-zA-Z-\s+ăâîșțĂÂÎȘȚ]+$/;
	const patternLastName = /^[a-zA-Z\s+ăâîșțĂÂÎȘȚ]+$/;
	const patternTLD = /^\.(com|org|net|mil|edu|ro|RO|COM|ORG|NET|MIL|EDU)+$/;
	const patternCompetitors = [
		/grilepolitie/,
		/grile-examene/,
		/grileexamen/,
		/gapol/,
		/academiadepolitie/,
		/grilegramaticaonline/,
		/politie/,
		/grile/,
		/academie/,
		/invata/,
		/studiaza/
	];

	if (!patternFirstName.test(firstName)) {
		return false;
	}

	if (!patternLastName.test(lastName)) {
		return false;
	}

	if (patternTLD.test(firstName) || patternTLD.test(lastName)) {
		return false;
	}

	let containsCompetitor = false;
	patternCompetitors.forEach((pattern) => {
		if (pattern.test(firstName) || pattern.test(lastName)) {
			containsCompetitor = true;
		}
	});

	if (containsCompetitor) {
		return false;
	}

	if (firstName.length <= 2) {
		return false;
	}

	if (lastName.length <= 2) {
		return false;
	}

	return true;
};

export const sanitaizeUsername = (firstName, lastName) => {
	const fName = firstName.toLowerCase();
	const lName = lastName.toLowerCase();

	return [
		fName.charAt(0).toUpperCase() + fName.slice(1),
		lName.charAt(0).toUpperCase() + lName.slice(1)
	];
};

export const containsUppercase = (str) => {
	return /[A-Z]/.test(str);
};
